export enum ThemeEnum {
  BLUE = 'blue',
  GREY = 'grey',
}
